// extracted by mini-css-extract-plugin
module.exports = {"quill":"GroupLevelAttributeTextArea_quill_1ju1E","quillDisabled":"GroupLevelAttributeTextArea_quillDisabled_2tKja"};